import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as api from '../../services/api';

// Async thunks for API calls
export const fetchLocations = createAsyncThunk('locations/fetchLocations', async () => {
  try {
    const response = await api.getLocations();
    return response.data;
  } catch (error) {
    console.error('Error fetching locations:', error);
    return [];
  }
});

export const createLocation = createAsyncThunk('locations/createLocation', async (locationData) => {
  const response = await api.createLocation(locationData);
  return response.data;
});

export const updateLocation = createAsyncThunk('locations/updateLocation', async ({ id, data }) => {
  const response = await api.updateLocation(id, data);
  return response.data;
});

export const deleteLocation = createAsyncThunk('locations/deleteLocation', async (id) => {
  await api.deleteLocation(id);
  return id;
});

const locationsSlice = createSlice({
  name: 'locations',
  initialState: {
    locations: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLocations.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLocations.fulfilled, (state, action) => {
        state.loading = false;
        state.locations = action.payload;
      })
      .addCase(fetchLocations.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(createLocation.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createLocation.fulfilled, (state, action) => {
        state.loading = false;
        state.locations.push({
          ...action.payload,
          id: action.payload._id || action.payload.id,
        });
      })
      .addCase(createLocation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(updateLocation.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateLocation.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.locations.findIndex(
          (l) => l.id === action.payload._id || l.id === action.payload.id || l._id === action.payload._id
        );
        if (index !== -1) {
          state.locations[index] = {
            ...action.payload,
            id: action.payload._id || action.payload.id,
          };
        }
      })
      .addCase(updateLocation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(deleteLocation.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteLocation.fulfilled, (state, action) => {
        state.loading = false;
        state.locations = state.locations.filter(
          (l) => l.id !== action.payload && l._id !== action.payload
        );
      })
      .addCase(deleteLocation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { clearError } = locationsSlice.actions;
export default locationsSlice.reducer;

